import { PERMISSION } from '@/constants/permission.constant';

const appMenuList = () => import('@/views/configuration/app-menu/List.vue');
const addAppMenu = () => import('@/views/configuration/app-menu/Add.vue');
const editAppMenu = () => import('@/views/configuration/app-menu/Edit.vue');

export const appMenuRoute = [
  {
    path: '/configuration/app-menus',
    name: 'app-menu-list',
    component: appMenuList,
    meta: { requiresAuth: false, permissions: [PERMISSION.APP_MENU_READ] },
  },

  {
    path: '/configuration/app-menus/create',
    name: 'app-menu-create',
    component: addAppMenu,
    meta: { requiresAuth: false, permissions: [PERMISSION.APP_MENU_CREATE] },
  },
  {
    path: '/configuration/app-menus/update',
    name: 'app-menu-edit',
    component: editAppMenu,
    meta: { requiresAuth: false, permissions: [PERMISSION.APP_MENU_UPDATE] },
  },
];
